import { FilterActions } from '@insync-students-constants/filters';
import { IFiltersState, FilterState, ReducerAction } from './FiltersContext.types';
function storeOpenAccordionsInLocalStorage(openAccordions: Set<any>) {
  if (window.localStorage) {
    window.localStorage.setItem('insync-student-lib-openAccordions', JSON.stringify(Array.from(openAccordions)));
  }
}

/**
 * filtersReducer
 * @param {IFiltersState}       state      - Current  Context state
 * @param {ReducerAction}       action     - Object with action to do and data to update
 */
export const filtersReducer = (state: IFiltersState, action: ReducerAction): IFiltersState => {
  switch (action.type) {
    case FilterActions.UPDATE_CURRICULA_SELECTED:
      {
        return {
          ...state,
          curricula: {
            ...state.curricula,
            selectedId: action.payload
          } as FilterState,
          courses: {
            ...state.courses,
            selectedId: null
          } as FilterState
        };
      }
    case FilterActions.UPDATE_COURSES_SELECTED:
      {
        return {
          ...state,
          courses: {
            ...state.courses,
            selectedId: action.payload
          } as FilterState
        };
      }
    case FilterActions.UPDATE_CURRICULA_LIST:
      {
        return {
          ...state,
          curricula: {
            list: action.payload,
            selectedId: null
          } as FilterState,
          courses: {
            list: [],
            selectedId: null
          }
        };
      }
    case FilterActions.UPDATE_COURSES_LIST:
      {
        return {
          ...state,
          courses: {
            list: action.payload,
            selectedId: null
          } as FilterState
        };
      }
    case FilterActions.ADD_CONTENT_ITEM:
      {
        const item = action.payload;
        const newContentId = item.parentData.id;
        return {
          ...state,
          filtersLoading: false,
          content: {
            ...state.content,
            [newContentId]: item
          }
        };
      }
    case FilterActions.OPEN_ACCORDION:
      {
        const {
          id: newAccordionId,
          parent: parentId
        } = action.payload;
        const openAccordions = new Set(state.openAccordions);

        // Filters all siblings so only one child is open
        if (parentId) {
          const parent = state.content[parentId];
          if (parent) {
            parent.childrenData.forEach(child => openAccordions.delete(child.id));
          }
        }
        openAccordions.add(newAccordionId);
        storeOpenAccordionsInLocalStorage(openAccordions);
        return {
          ...state,
          openAccordions
        };
      }
    case FilterActions.CLOSE_ACCORDION:
      {
        const openAccordions = new Set(state.openAccordions);
        openAccordions.delete(action.payload);
        storeOpenAccordionsInLocalStorage(openAccordions);
        return {
          ...state,
          openAccordions
        };
      }
    case FilterActions.SET_LOADING_INDICATOR:
      {
        return {
          ...state,
          filtersLoading: action.payload
        };
      }
  }
};